"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var FaqNavigation = /** @class */ (function (_super) {
    __extends(FaqNavigation, _super);
    function FaqNavigation(props) {
        var _this = _super.call(this, props) || this;
        _this.buildDesk = function (links) {
            return links
                ? links.map(function (link, i) { return (React.createElement("li", { key: i, className: "relative md:flex-grow text-center min-w-12" },
                    React.createElement("a", { href: link.url, title: link.title, className: "block relative font-extrabold no-underline leading-2 text-md border-b-2 border-transparent py-1-4 hover:text-navy-dark transition-fast " + (_this.state.active == link.url ? "text-navy-dark border-navy" : "text-blue-grey") }, link.title),
                    React.createElement("span", { className: "w-" + (link.active ? "full" : "0") + " group-hover:w-full transition-all absolute pin-b pin-x h-px -mb-px bg-black" }))); })
                : [];
        };
        _this.buildMobile = function (items) {
            return items
                ? items.map(function (item, i) { return (React.createElement("li", { key: i, className: "h-12 text-grey flex items-center cursor-pointer\n              bg-white transition-all hover:bg-grey-light\n              ", onClick: function (e) {
                        _this.toggleOpen();
                    } },
                    React.createElement("a", { href: item.url, title: item.title, className: "no-underline text-black p-4 w-full" }, item.title),
                    i == 0 ? (React.createElement("span", { className: "mr-4 absolute pin-r" })) : null)); })
                : [];
        };
        _this.state = {
            open: false,
            active: _this.props.active,
            menu: _this.props.data.linklist[next_components_1.ShopifyNext.Utils.getMenu(_this.props.data.section.header.settings.faq_menu)]
        };
        return _this;
    }
    FaqNavigation.prototype.render = function () {
        return (React.createElement("div", { className: "md:w-full" },
            React.createElement("section", { className: "w-full bg-white md:h-full md:px-11" },
                React.createElement("div", { className: "md:w-full overflow-hidden block" },
                    React.createElement("ul", { className: "md:w-full list-reset md:pr-8 flex flex-no-wrap overflow-y-hidden overflow-x-auto" }, this.buildDesk(this.state.menu.links))))));
    };
    FaqNavigation.prototype.toggleOpen = function () {
        this.setState({
            open: !this.state.open
        });
    };
    return FaqNavigation;
}(React.PureComponent));
exports.FaqNavigation = FaqNavigation;
